import { useEffect, useRef, useState } from "react";
import { API_URL } from "../services/api";
import { useNavigate } from "react-router-dom";
import "./Dashboard.css";
import DataEntryPopup from "../components/DataEntryPopup";
import Videoteca from "../components/Videoteca";
import GeneralRoutineAI from "../components/GeneralRoutineAI";
import RutinaPanel from "../components/RutinaPanel";
import ContenidoPanel from "../components/ContenidoPanel";
import ListaCompra from "../components/ListaCompra";
import FichaCliente from "../components/FichaCliente";
import ActividadesPanel from "../components/ActividadesPanel";
import ComunidadPanel from "../components/ComunidadPanel";
import HabitosPanel from "../components/HabitosPanel";
import Avatar from "../components/Avatar";
import VideoBienvenida from "../components/VideoBienvenida";
import { PsicologoIA, CocineroIA } from "../components/ProximamentePanel";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import SideNav from "../components/SideNav";
import FoodEntryPopup from "../components/FoodEntryPopup";
import {
  FiActivity,
  FiCalendar,
  FiCamera,
  FiCoffee,
  FiHome,
  FiMenu,
  FiMessageCircle,
  FiPlay,
  FiPlayCircle,
  FiBookOpen,
  FiShoppingCart,
  FiClipboard,
  FiSmile,
  FiUsers,
  FiTrendingUp,
  FiHeart,
  FiThermometer,
} from "react-icons/fi";
import ExerciseEntryPopup from "../components/ExerciseEntryPopup";
import FoodHistory from "../components/FoodHistory";
import CalendarPanel from "../components/CalendarPanel";
import TextChat from "../components/TextChat";
import MiniSemanaMeals from "../components/MiniSemanaMeals";
import UserInfoPopup from "../components/UserInfoPopup";
import PhotoInfoPopup from "../components/PhotoInfoPopup";
import { getSession, clearSession } from "../utils/session";
import axios from "axios"; // arriba del archivo

function calcularMetaCaloriasSimple({ peso, altura, objetivo }) {
  let calorias = 10 * peso + 6.25 * altura + 500;
  if (objetivo === "perder") calorias -= 500;
  else if (objetivo === "subir" || objetivo === "ganar") calorias += 400;
  return Math.max(1200, Math.round(calorias));
}

const MENU = [
  { key: "dashboard", label: "Inicio", Icono: FiHome },
  { key: "mensajes", label: "Mensajes", Icono: FiMessageCircle },
  { key: "rutina", label: "Rutina", Icono: FiActivity },
  { key: "videoteca", label: "Videoteca", Icono: FiPlayCircle },
  { key: "contenido", label: "Contenido", Icono: FiBookOpen },
  { key: "planAlim", label: "Plan de comidas", Icono: FiCoffee },
  { key: "compra", label: "Lista de la compra", Icono: FiShoppingCart },
  { key: "calendario", label: "Calendario", Icono: FiCalendar },
  { key: "habitos", label: "Hábitos", Icono: FiTrendingUp },
  { key: "comunidad", label: "Comunidad", Icono: FiUsers },
  { key: "actividades", label: "Entretenimiento", Icono: FiSmile },
  { key: "camara", label: "Foto de comida", Icono: FiCamera },
  { key: "psicologo", label: "Psicólogo IA", Icono: FiHeart },
  { key: "cocinero", label: "Cocinero IA", Icono: FiThermometer },
  { key: "ficha", label: "Mi ficha", Icono: FiClipboard },
];

const TITULOS = {
  dashboard: (user) => (user?.firstName ? `Hola, ${user.firstName}` : "Hola"),
  mensajes: () => "Mensajes",
  rutina: () => "Tu rutina",
  videoteca: () => "Videoteca",
  contenido: () => "Para ti",
  planAlim: () => "Plan de comidas",
  compra: () => "Lista de la compra",
  calendario: () => "Calendario",
  habitos: () => "Hábitos y motivación",
  comunidad: () => "Comunidad",
  actividades: () => "Entretenimiento",
  ficha: () => "Mi ficha",
  psicologo: () => "Psicólogo IA",
  cocinero: () => "Cocinero IA",
};

const FECHA_HOY = new Date().toLocaleDateString("es-ES", {
  weekday: "long",
  day: "numeric",
  month: "long",
});

function Dashboard() {
  const [user, setUser] = useState(null);
  const [caloriesToday, setCaloriesToday] = useState(0);
  const [caloriesMonth, setCaloriesMonth] = useState(0);
  const [caloriesBurnedMonth, setCaloriesBurnedMonth] = useState(0);
  const [workoutStreak, setWorkoutStreak] = useState(0);
  // Entrenamientos reales (models/WorkoutLog), no el registro manual de ejercicio
  const [resumenEntrenos, setResumenEntrenos] = useState(null);

  // POPUPS INDIVIDUALES
  const [showPopup, setShowPopup] = useState(false);
  const [showFoodPopup, setShowFoodPopup] = useState(false);
  const [showExercisePopup, setShowExercisePopup] = useState(false);
  const [refreshFoodHistory, setRefreshFoodHistory] = useState(false);
  const [showPhotoInfo, setShowPhotoInfo] = useState(false);
  const [menuAbierto, setMenuAbierto] = useState(false);

  // Popup de análisis IA
  const [fotoComida, setFotoComida] = useState(null);
  const [showUserPopup, setShowUserPopup] = useState(false);

  const navigate = useNavigate();

  // Control del menú principal
  const [tab, setTab] = useState("dashboard");

  // === Lógica de la cámara ===
  const fileInputRef = useRef();

  const handleCameraClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
      fileInputRef.current.click();
    }
  };

  // Sin IA de visión en local: la foto abre el registro de comida como
  // referencia y el nombre se elige del catálogo local de recetas
  const handlePhoto = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setFotoComida(URL.createObjectURL(file));
    setShowFoodPopup(true);
  };

  const cerrarRegistroComida = () => {
    if (fotoComida) URL.revokeObjectURL(fotoComida);
    setFotoComida(null);
    setShowFoodPopup(false);
  };

  // --- AUTH ---
  useEffect(() => {
    getSession().then(({ token, user }) => {
      if (user) {
        setUser(user);
      } else {
        // "/login" no existe en App.js: llevaba a una pantalla en blanco
        navigate("/");
      }
    });
  }, [navigate]);

  // --- DATOS ---
  useEffect(() => {
    const isSameDay = (dateA, dateB) => {
      return (
        dateA.getFullYear() === dateB.getFullYear() &&
        dateA.getMonth() === dateB.getMonth() &&
        dateA.getDate() === dateB.getDate()
      );
    };

    const fetchUserData = async () => {
      try {
        const { token } = await getSession();
        const foodResponse = await axios.get(
          `${API_URL}/foods`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const today = new Date();
        const firstDayOfMonth = new Date(
          today.getFullYear(),
          today.getMonth(),
          1
        );

        const todayCalories = foodResponse.data
          .filter((food) => {
            if (!food.date) return false;
            const foodDate = new Date(food.date);
            return isSameDay(foodDate, today);
          })
          .reduce((total, food) => total + Number(food.calories || 0), 0);

        const monthCalories = foodResponse.data
          .filter((food) => {
            if (!food.date) return false;
            const foodDate = new Date(food.date);
            return foodDate >= firstDayOfMonth;
          })
          .reduce((total, food) => total + Number(food.calories || 0), 0);

        const exerciseResponse = await axios.get(
          `${API_URL}/exercises`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const monthBurnedCalories = exerciseResponse.data
          .filter((exercise) => {
            if (!exercise.date) return false;
            const exDate = new Date(exercise.date);
            return exDate >= firstDayOfMonth;
          })
          .reduce(
            (total, exercise) => total + Number(exercise.caloriesBurned || 0),
            0
          );

        const workoutDates = exerciseResponse.data.map((exercise) =>
          new Date(exercise.date).toDateString()
        );
        const uniqueWorkoutDates = [...new Set(workoutDates)];
        const sortedDates = uniqueWorkoutDates.sort(
          (a, b) => new Date(b) - new Date(a)
        );

        let streak = 0;
        for (let i = 0; i < sortedDates.length; i++) {
          if (
            i === 0 ||
            new Date(sortedDates[i]).getTime() ===
              new Date(sortedDates[i - 1]).getTime() + 86400000
          ) {
            streak++;
          } else break;
        }

        setCaloriesToday(todayCalories);
        setCaloriesMonth(monthCalories);
        setCaloriesBurnedMonth(monthBurnedCalories);
        setWorkoutStreak(streak);
      } catch (err) {
        console.error("Error fetching user data:", err);
      }
    };

    fetchUserData();
  }, [refreshFoodHistory]);

  // Resumen de entrenamientos: racha, entrenos del mes y kilos movidos.
  // Es lo que alimenta la cabecera de Inicio.
  useEffect(() => {
    (async () => {
      try {
        const { token } = await getSession();
        const res = await axios.get(`${API_URL}/workouts/resumen`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setResumenEntrenos(res.data);
      } catch {
        // Sin histórico todavía: la tarjeta se queda en su estado inicial
      }
    })();
  }, [tab]);

  // === CÁLCULO DE META PERSONALIZADA ===
  let metaDiaria = 2000; // valor default
  if (user) {
    metaDiaria = calcularMetaCaloriasSimple({
      peso: user.weight || 70,
      altura: user.height || 170,
      objetivo:
        user.goal === "subir"
          ? "subir"
          : user.goal === "bajar"
          ? "perder"
          : "mantener",
    });
  }
  const diasMes = new Date().getDate();
  const calorieTarget = metaDiaria * 30;
  const progress = Math.min((caloriesMonth / calorieTarget) * 100, 100);

  // --- CERRAR SESIÓN ---
  const handleLogout = async () => {
    await clearSession();
    navigate("/");
    window.location.reload();
  };

  // --- RENDER POR TABS ---
  function renderTab() {
    switch (tab) {
      case "dashboard":
        return (
          <>
            {/* Vídeo de explicación de la app (el cliente puede ocultarlo) */}
            <VideoBienvenida />
            {/* Lo primero: entrenar. Es a lo que viene el usuario. */}
            <section className="dash-entreno">
              <div className="dash-entreno-txt">
                <span className="dash-entreno-eti">
                  {resumenEntrenos?.ultimo
                    ? `Último: ${resumenEntrenos.ultimo.sesionNombre || "entrenamiento"}`
                    : "Empieza cuando quieras"}
                </span>
                <h2 className="dash-entreno-titulo">Tu entrenamiento</h2>
                {resumenEntrenos?.racha > 0 && (
                  <p className="dash-entreno-racha">
                    Llevas {resumenEntrenos.racha}{" "}
                    {resumenEntrenos.racha === 1 ? "día seguido" : "días seguidos"} entrenando
                  </p>
                )}
              </div>
              <button className="dash-entreno-btn" onClick={() => setTab("rutina")}>
                <FiPlay /> Entrenar
              </button>
            </section>

            {resumenEntrenos && resumenEntrenos.entrenosMes > 0 && (
              <div className="dash-entreno-cifras">
                <div>
                  <strong>{resumenEntrenos.entrenosMes}</strong>
                  <span>entrenos este mes</span>
                </div>
                <div>
                  <strong>{(resumenEntrenos.volumenMes || 0).toLocaleString("es-ES")}</strong>
                  <span>kg movidos</span>
                </div>
                <div>
                  <strong>{resumenEntrenos.minutosMes}</strong>
                  <span>minutos</span>
                </div>
              </div>
            )}

            <section className="app-panel dash-hoy">
              <div className="dash-hoy-texto">
                <span className="dash-hoy-label">Calorías de hoy</span>
                <span className="dash-hoy-cifra">
                  {caloriesToday}
                  <small> kcal</small>
                </span>
                <span className="dash-hoy-meta">Tu meta diaria: {Math.round(metaDiaria)} kcal</span>
              </div>
              <div className="dash-anillo">
                <CircularProgressbarWithChildren
                  value={progress}
                  strokeWidth={9}
                  styles={buildStyles({
                    pathColor: "var(--t-green)",
                    trailColor: "rgba(238, 244, 240, 0.12)",
                    strokeLinecap: "round",
                  })}
                >
                  <strong className="dash-anillo-cifra">{Math.round(progress)}%</strong>
                  <span className="dash-anillo-label">del mes</span>
                </CircularProgressbarWithChildren>
              </div>
            </section>

            <div className="dash-stats">
              <div className="app-card dash-stat">
                <span>Consumidas este mes</span>
                <strong>{caloriesMonth} kcal</strong>
              </div>
              <div className="app-card dash-stat">
                <span>Quemadas este mes</span>
                <strong>{caloriesBurnedMonth} kcal</strong>
              </div>
              <div className="app-card dash-stat">
                <span>Racha entrenando</span>
                <strong>
                  {resumenEntrenos?.racha ?? workoutStreak}{" "}
                  {(resumenEntrenos?.racha ?? workoutStreak) === 1 ? "día" : "días"}
                </strong>
              </div>
            </div>

            <div className="dash-acciones">
              <button className="app-btn" onClick={() => setShowFoodPopup(true)}>
                + Registrar comida
              </button>
              <button className="app-btn app-btn-quiet" onClick={() => setShowExercisePopup(true)}>
                + Registrar ejercicio
              </button>
            </div>

            {/* HISTORIAL DE ALIMENTOS */}
            <FoodHistory key={refreshFoodHistory} />

            {/* POPUP MIXTO ANTIGUO, si quieres lo puedes quitar */}
            <button
              className="data-entry-button"
              onClick={() => setShowPopup(true)}
              style={{ display: "none" }}
            >
              Ingresar Datos del Día
            </button>
            {showPopup && (
              <DataEntryPopup onClose={() => setShowPopup(false)} />
            )}
          </>
        );
      case "rutina":
        return (
          <>
            {user && (
              <RutinaPanel
                userId={user._id || user.id}
                onResumenCambiado={setResumenEntrenos}
              />
            )}
            {user && (
              <GeneralRoutineAI
                peso={user.weight}
                altura={user.height}
                objetivo={user.goal}
              />
            )}
          </>
        );

      case "videoteca":
        return <Videoteca />;
      case "contenido":
        return <ContenidoPanel />;
      case "planAlim":
        return <MiniSemanaMeals />;
      case "compra":
        return <ListaCompra />;
      case "calendario":
        return (
          <CalendarPanel
            userId={user && (user._id || user.id)}
            onContactar={() => setTab("mensajes")}
          />
        );
      case "mensajes":
        return <TextChat />;
      case "habitos":
        return <HabitosPanel />;
      case "comunidad":
        return <ComunidadPanel />;
      case "actividades":
        return <ActividadesPanel />;
      case "ficha":
        return <FichaCliente />;
      case "psicologo":
        return <PsicologoIA />;
      case "cocinero":
        return <CocineroIA />;
      default:
        return null;
    }
  }

  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        <div className="dashboard-header-inner">
          <button
            type="button"
            className="menu-btn"
            onClick={() => setMenuAbierto(true)}
            aria-label="Abrir menú"
          >
            <FiMenu />
          </button>
          <span className="brand">
            <span className="brand-mark">
              <img src="/titan-mark.png" alt="" />
            </span>
            <span className="brand-name">Titan Training</span>
          </span>
          <div className="dashboard-header-acciones">
            <button
              type="button"
              className="user-avatar"
              onClick={() => setShowUserPopup(true)}
              aria-label="Ver perfil"
              title="Ver perfil"
            >
              <Avatar
                userId={user?._id || user?.id}
                nombre={user?.firstName}
                apellido={user?.lastName}
                tamano={38}
              />
            </button>
          </div>
        </div>
      </header>

      <main className="dashboard-content">
        <h1 className="dash-titulo">{TITULOS[tab] ? TITULOS[tab](user) : ""}</h1>
        {tab === "dashboard" && <p className="dash-fecha">{FECHA_HOY}</p>}
        {renderTab()}
      </main>

      {/* POPUPS */}
      {showFoodPopup && (
        <FoodEntryPopup
          foto={fotoComida}
          onClose={cerrarRegistroComida}
          onSaved={() => setRefreshFoodHistory((x) => !x)}
        />
      )}
      {showExercisePopup && (
        <ExerciseEntryPopup
          onClose={() => setShowExercisePopup(false)}
          onSaved={() => setRefreshFoodHistory((x) => !x)}
        />
      )}

      {/* Input oculto para la cámara */}
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        capture="environment"
        style={{ display: "none" }}
        onChange={handlePhoto}
      />

      <SideNav
        items={MENU}
        selected={tab}
        abierto={menuAbierto}
        onCerrar={() => setMenuAbierto(false)}
        onSelect={(key) => {
          if (key === "camara") {
            setShowPhotoInfo(true);
          } else {
            setTab(key);
          }
        }}
        pie={
          <button
            type="button"
            className="sidenav-usuario"
            onClick={() => setShowUserPopup(true)}
            title="Ver perfil"
          >
            <img src={user?.photoURL || "/avatar-default.png"} alt="" />
            <span className="sidenav-usuario-texto">
              <strong>
                {user?.firstName} {user?.lastName}
              </strong>
              <span>{user?.email}</span>
            </span>
          </button>
        }
      />
      {showPhotoInfo && (
        <PhotoInfoPopup
          onClose={() => setShowPhotoInfo(false)}
          onGoToCamera={() => {
            setShowPhotoInfo(false);
            handleCameraClick();
          }}
        />
      )}

      {showUserPopup && (
        <UserInfoPopup
          user={user}
          onClose={() => setShowUserPopup(false)}
          onLogout={handleLogout}
          onIrAFicha={() => setTab("ficha")}
        />
      )}
    </div>
  );
}

export default Dashboard;
